module.exports = __webpack_public_path__ + "static/media/logo-black-horizontal.29049cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-black-horizontal.png
// module id = 195
// module chunks = 0